import { Component, Input } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

@Component({
    selector: 'app-delivered-document-cell-renderer',
    standalone: true,
    imports: [CommonModule, DecimalPipe],
    template: `
                                                    <ng-container *ngIf="params?.data?.deliveryDocument as doc; else noDelivery">
                                                        <ng-container *ngIf="doc.serial && doc.externalDocument; else singleOrNone">
                                                            {{ doc.serial }}<br>{{ doc.externalDocument }}
                                                        </ng-container>
                                                        <ng-template #singleOrNone>
                                                            {{ doc.serial || doc.externalDocument || '-' }}
                                                        </ng-template>
                                                    </ng-container>
                                                    <ng-template #noDelivery>-</ng-template>
  `,
})
export class DeliveredDocumentLogisticCellRendererComponent implements CellRenderer<any> {
    @Input() params!: CellRendererParams<any>;
}
